import { call, put, takeLatest } from 'redux-saga/effects';
import { httpRequestsOnLoadActions } from '../http_requests_on_load';
import { httpRequestsOnSuccessActions } from '../http_requests_on_success';
import {
    ADD_DASHBOARD_USER_KPI,
    DELETE_DASHBOARD_USER_KPI,
    GET_DASHBOARD_ALL_KPIS,
    GET_DASHBOARD_ALL_KPIS_SUCCESS,
    GET_DASHBOARD_ASSIGNED_CLIENTS,
    GET_DASHBOARD_ASSIGNED_CLIENTS_SUCCESS,
    GET_DASHBOARD_CLIENTS_OVERVIEW,
    GET_DASHBOARD_CLIENTS_OVERVIEW_SUCCESS,
    GET_DASHBOARD_CREDENTIAL_ALERTS,
    GET_DASHBOARD_CREDENTIAL_ALERTS_SUCCESS,
    GET_DASHBOARD_MY_TASKS,
    GET_DASHBOARD_MY_TASKS_SUCCESS,
    GET_DASHBOARD_EXPIRING_AUTHS,
    GET_DASHBOARD_EXPIRING_AUTHS_SUCCESS,
    GET_DASHBOARD_INSURANCE_ALERTS,
    GET_DASHBOARD_INSURANCE_ALERTS_SUCCESS,
    GET_DASHBOARD_CLIENT_DOCUMENT_ALERTS,
    GET_DASHBOARD_CLIENT_DOCUMENT_ALERTS_SUCCESS,
    GET_DASHBOARD_SESSION_NOTE_REQUESTS,
    GET_DASHBOARD_SESSION_NOTE_REQUESTS_SUCCESS,
    GET_DASHBOARD_UPCOMING_APPTS,
    GET_DASHBOARD_UPCOMING_APPTS_SUCCESS,
    GET_DASHBOARD_USER_FILTERED_KPIS,
    GET_DASHBOARD_USER_FILTERED_KPIS_SUCCESS,
    GET_DASHBOARD_USER_KPIS,
    GET_DASHBOARD_USER_KPIS_SUCCESS,
    REORDER__DASHBOARD_KPIS,
} from './dashboard.types';
import { dashboardService } from './dashboard.service';

/** Dashboard */
function updateOriginalKpis(userKpis, kpis) {
    const kpiIds = new Set(userKpis?.map((kpi) => kpi.id));

    kpis.forEach((kpi) => {
        kpi.added = kpiIds.has(kpi.id);
    });
    return kpis;
}

function* getUserFilteredKpis(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    try {
        const kpis = yield call(dashboardService.getAllDashboardKpisService, action?.payload?.params);
        const userKpis = yield call(dashboardService.getDashboardUserKpisService, action?.payload?.params);
        const resFiltered = updateOriginalKpis(userKpis?.data, kpis?.data || []);
        yield put({
            type: GET_DASHBOARD_USER_FILTERED_KPIS_SUCCESS,
            payload: resFiltered,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    }
}

function* getAllKpis(action) {
    if (action?.payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    try {
        const res = yield call(dashboardService.getAllDashboardKpisService, action?.payload?.params);
        yield put({
            type: GET_DASHBOARD_ALL_KPIS_SUCCESS,
            payload: res?.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    }
}

function* getUserKpis(action) {
    if (action?.payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    try {
        const res = yield call(dashboardService.getDashboardUserKpisService, action?.payload?.params);
        yield put({
            type: GET_DASHBOARD_USER_KPIS_SUCCESS,
            payload: res?.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    }
}

function* reorderKpis(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        const idList = action?.payload?.body?.map((kpi) => kpi.id);
        const res = yield call(dashboardService.reorderDashboardKpisService, idList, action?.payload?.params);

        yield put({
            type: GET_DASHBOARD_USER_KPIS_SUCCESS,
            payload: res?.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    }
}

function* deleteUserKpi(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(dashboardService.deleteDashboardUserKpiService, action?.payload?.id);
        const kpis = yield call(dashboardService.getAllDashboardKpisService);
        const userKpis = yield call(dashboardService.getDashboardUserKpisService, action?.payload?.params);
        yield put({
            type: GET_DASHBOARD_USER_FILTERED_KPIS_SUCCESS,
            payload: updateOriginalKpis(userKpis?.data, kpis?.data),
        });
        yield put({
            type: GET_DASHBOARD_USER_KPIS_SUCCESS,
            payload: userKpis?.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    }
}
function* addUserKpi(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(dashboardService.addDashboardUserKpiService, action?.payload?.id);
        const kpis = yield call(dashboardService.getAllDashboardKpisService);
        const userKpis = yield call(dashboardService.getDashboardUserKpisService, action?.payload?.params);
        yield put({
            type: GET_DASHBOARD_USER_FILTERED_KPIS_SUCCESS,
            payload: updateOriginalKpis(userKpis?.data, kpis?.data),
        });
        yield put({
            type: GET_DASHBOARD_USER_KPIS_SUCCESS,
            payload: userKpis?.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    }
}

/** Dashboard Widgets Data */

function* getDashboardUpcomingAppts(action) {
    if (action?.payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    try {
        const res = yield call(dashboardService.getWidgetsDataService, action?.payload?.url, action?.payload?.params);
        yield put({
            type: GET_DASHBOARD_UPCOMING_APPTS_SUCCESS,
            payload: res?.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    }
}

function* getDashboardClientsOverview(action) {
    if (action?.payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    try {
        const res = yield call(dashboardService.getWidgetsDataService, action?.payload?.url, action?.payload?.params);
        yield put({
            type: GET_DASHBOARD_CLIENTS_OVERVIEW_SUCCESS,
            payload: res?.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    }
}

function* getDashboardCredentialAlerts(action) {
    if (action?.payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    try {
        const res = yield call(dashboardService.getWidgetsDataService, action?.payload?.url, action?.payload?.params);
        yield put({
            type: GET_DASHBOARD_CREDENTIAL_ALERTS_SUCCESS,
            payload: res?.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    }
}

function* getDashboardAssignedClients(action) {
    if (action?.payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    try {
        const res = yield call(dashboardService.getWidgetsDataService, action?.payload?.url, action?.payload?.params);
        yield put({
            type: GET_DASHBOARD_ASSIGNED_CLIENTS_SUCCESS,
            payload: res?.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    }
}

function* getDashboardMyTasks(action) {
    if (action?.payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    try {
        const res = yield call(dashboardService.getWidgetsDataService, action?.payload?.url, action?.payload?.params);
        yield put({
            type: GET_DASHBOARD_MY_TASKS_SUCCESS,
            payload: res?.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    }
}

/** End */

function* getDashboardExpiringAuths(action) {
    if (action?.payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    try {
        const res = yield call(dashboardService.getWidgetsDataService, action?.payload?.url, action?.payload?.params);
        yield put({
            type: GET_DASHBOARD_EXPIRING_AUTHS_SUCCESS,
            payload: res?.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    }
}

/** End */

function* getDashboardInsuranceAlerts(action) {
    if (action?.payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    try {
        const res = yield call(dashboardService.getWidgetsDataService, action?.payload?.url, action?.payload?.params);
        yield put({
            type: GET_DASHBOARD_INSURANCE_ALERTS_SUCCESS,
            payload: res?.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    }
}

function* getDashboardClientDocumentAlerts(action) {
    if (action?.payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    try {
        const res = yield call(dashboardService.getWidgetsDataService, action?.payload?.url, action?.payload?.params);
        yield put({
            type: GET_DASHBOARD_CLIENT_DOCUMENT_ALERTS_SUCCESS,
            payload: res?.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    }
}

function* getDashboardSessionNoteRequests(action) {
    if (action?.payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    try {
        const res = yield call(dashboardService.getWidgetsDataService, action?.payload?.url, action?.payload?.params);
        yield put({
            type: GET_DASHBOARD_SESSION_NOTE_REQUESTS_SUCCESS,
            payload: res?.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    }
}

/** End */

export const watchDashboard = function* watchDashboardSaga() {
    /** Dashboard */
    yield takeLatest(GET_DASHBOARD_USER_FILTERED_KPIS, getUserFilteredKpis);
    yield takeLatest(GET_DASHBOARD_ALL_KPIS, getAllKpis);
    yield takeLatest(GET_DASHBOARD_USER_KPIS, getUserKpis);
    yield takeLatest(REORDER__DASHBOARD_KPIS, reorderKpis);
    yield takeLatest(DELETE_DASHBOARD_USER_KPI, deleteUserKpi);
    yield takeLatest(ADD_DASHBOARD_USER_KPI, addUserKpi);
    /** End */

    /** Dashboard Widgets Data */
    yield takeLatest(GET_DASHBOARD_UPCOMING_APPTS, getDashboardUpcomingAppts);
    yield takeLatest(GET_DASHBOARD_CLIENTS_OVERVIEW, getDashboardClientsOverview);
    yield takeLatest(GET_DASHBOARD_CREDENTIAL_ALERTS, getDashboardCredentialAlerts);
    yield takeLatest(GET_DASHBOARD_ASSIGNED_CLIENTS, getDashboardAssignedClients);
    yield takeLatest(GET_DASHBOARD_MY_TASKS, getDashboardMyTasks);
    yield takeLatest(GET_DASHBOARD_EXPIRING_AUTHS, getDashboardExpiringAuths);
    yield takeLatest(GET_DASHBOARD_INSURANCE_ALERTS, getDashboardInsuranceAlerts);
    yield takeLatest(GET_DASHBOARD_CLIENT_DOCUMENT_ALERTS, getDashboardClientDocumentAlerts);
    yield takeLatest(GET_DASHBOARD_SESSION_NOTE_REQUESTS, getDashboardSessionNoteRequests);
    /** End */
};
